import React from "react";
import { client_config } from "../../utils/clientConfigs";

// UI Components
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";

const PERMISSION_OPTIONS = [
  { label: "Read Only", value: 1 },
  { label: "User", value: 2 },
  { label: "Admin", value: 3 },
  { label: "Super Admin", value: 4 },
  { label: "Internal", value: 5 },
];

const Profile = ({ selected, user, onChange, onSubmit }) => {
  if (selected !== "profile") {
    return null;
  }

  const permission = PERMISSION_OPTIONS.find(({ value }) => user.group_id_bint === value) || {
    label: "Contact Administrator",
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle tag="h5" className="mb-0">
          Profile
        </CardTitle>
      </CardHeader>

      <CardBody>
        <Form>
          <Row form>
            <Col md="6">
              <FormGroup>
                <Label for="email_vch">Email</Label>
                <Input
                  type="text"
                  name="email_vch"
                  placeholder="email address"
                  value={user.email_vch || ""}
                  onChange={onChange}
                  readOnly={client_config.disabled_features.user_management}
                />
              </FormGroup>
            </Col>

            {/* AMRN-1084 Add field for permission level (visual conf of SSO Permission Level) */}
            {client_config.name === "ameren" && (
              <Col md="6">
                <FormGroup>
                  <Label for="permission">Permission Level</Label>
                  <Input
                    type="text"
                    name="permission"
                    placeholder="contact administrator"
                    value={permission.label}
                    readOnly={client_config.disabled_features.user_management}
                  />
                </FormGroup>
              </Col>
            )}
          </Row>

          <Row form>
            <Col md={6}>
              <FormGroup>
                <Label for="firstName">First name</Label>
                <Input
                  type="text"
                  name="firstname_vch"
                  placeholder="First name"
                  value={user.firstname_vch || ""}
                  onChange={onChange}
                  readOnly={client_config.disabled_features.user_management}
                />
              </FormGroup>
            </Col>

            <Col md={6}>
              <FormGroup>
                <Label for="lastName">Last name</Label>
                <Input
                  type="text"
                  name="lastname_vch"
                  placeholder="First name"
                  value={user.lastname_vch || ""}
                  onChange={onChange}
                  readOnly={client_config.disabled_features.user_management}
                />
              </FormGroup>
            </Col>
          </Row>

          <Button color="primary" onClick={onSubmit}>
            Save changes
          </Button>
        </Form>
      </CardBody>
    </Card>
  );
};

export default Profile;
